/**
 * True when the URL carries an OAuth auth response (state plus code or error) that msal-browser v5
 * expects the redirect-URI page to hand to broadcastResponseToMainFrame. The bridge classifies the
 * interaction from MSAL's state metadata: popup and hidden-iframe responses are relayed to the
 * main frame, top-level redirect returns are cached and navigated back to the origin URL. Window
 * shape (opener/top) must not be used to tell these apart — COOP on the identity provider severs
 * window.opener, which would leave a popup response unrelayed and the waiting request hanging.
 */
export const hasAuthResponseInUrl = (location: Pick<Location, 'search' | 'hash'>): boolean => {
  const authResponse = `${location.search}${location.hash}`;
  return /[?#&]state=/.test(authResponse) && /[?#&](code|error)=/.test(authResponse);
};
